export default __webpack_public_path__ + "static/media/ManOnBoat.787ddffa.svg";